import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ScanCameraPage } from './scan-camera.page';

const routes: Routes = [
  {
    path: '',
    component: ScanCameraPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ScanCameraPageRoutingModule {}
